// File: src/App.js
// Experten-gesteuertes Layout-Routing für Experts4Germany

import "./App.css";

import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import RoleGate from "./components/auth/RoleGate";
import { AppearanceProvider } from "./context/AppearanceContext";

import NewsTicker from "./components/NewsTicker";              // global montiert
import config from "./config/config";                          // für API_BASE_URL
import { isPrerenderUserAgent } from "./utils/prerender";

// Seiten & Dashboards
import Home from "./pages/Home";
import Leitbild from "./pages/Leitbild";
import Nachrichten from "./pages/Nachrichten";
import NachrichtenArtikel from "./pages/NachrichtenArtikel";
import PublicRoadmapPage from "./pages/PublicRoadmapPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ApplicantFrontdoorPage from "./pages/ApplicantFrontdoorPage";
import AdminCoreUiProShowcasePage from "./pages/AdminCoreUiProShowcasePage";
import AdminDashboard from "./pages/AdminDashboard";
import UserAdmin from "./pages/UserAdmin";
import AdminKvpInbox from "./pages/AdminKvpInbox";
import AdminTrustFraudCenter from "./pages/Admin/AdminTrustFraudCenter";
import AccountSettings from "./pages/AccountSettings";
import ApplicantDashboardWithCoach from "./pages/ApplicantDashboardWithCoach";
import ApplicantAchievements from "./pages/ApplicantAchievements";
import ApplicantEditProfile from "./pages/ApplicantEditProfile";
import ApplicantApplicationWorkspace from "./pages/ApplicantApplicationWorkspace";
import ApplicantB1Workspace from "./pages/ApplicantB1Workspace";
import ApplicantFilingRequests from "./pages/ApplicantFilingRequests";
import ApplicantMatches from "./pages/ApplicantMatches";
import ApplicantMessages from "./pages/ApplicantMessages";
import { ApplicantCoachProvider } from "./components/applicant/ApplicantCoachContext";
import EmployerWorkspacePage from "./pages/employer/EmployerWorkspacePage";
import EmployerJobsPage from "./pages/employer/EmployerJobsPage";
import EmployerDocumentsPage from "./pages/employer/EmployerDocumentsPage";
import EmployerCompliancePage from "./pages/employer/EmployerCompliancePage";
import EmployerIntegrationPage from "./pages/employer/EmployerIntegrationPage";
import EmployerAnalyticsPage from "./pages/employer/EmployerAnalyticsPage";
import EmployerProfilePage from "./pages/employer/EmployerProfilePage";
import {
  EmployerLegacyAuthoringRedirect,
  EmployerLegacyCandidatesRedirect,
  EmployerLegacyCreateRedirect,
  EmployerLegacyEditRedirect,
  EmployerLegacyManageRedirect,
  EmployerLegacyPreviewRedirect,
} from "./pages/employer/EmployerLegacyRedirects";
import { EmployerModeProvider } from "./components/employer/EmployerModeContext";
import PressDashboard from "./pages/PressDashboard";
import BlogAdmin from "./pages/BlogAdmin/BlogAdmin";
import BlogEditor from "./pages/BlogAdmin/BlogEditor";
import WissensTest from "./pages/WissensTest";
import WtStart from "./pages/wt/WtStart";
import WtRun from "./pages/wt/WtRun";
import WtResult from "./pages/wt/WtResult";
import WtHistory from "./pages/wt/WtHistory";
import NewsTickerAdmin from "./pages/NewsTickerAdmin";
import AdminNewsPage from "./pages/AdminNewsPage";
import SecurityDashboard from "./pages/SecurityDashboard";
import SystemStatusAdmin from "./pages/SystemStatusAdmin";
import ChatBotAdmin from "./pages/ChatBotAdmin";
import ChatbotFaqAdmin from "./pages/ChatbotFaqAdmin";
import GPTMaintainerAdmin from "./pages/Admin/GPTMaintainerAdmin";
import GPTDocAgentAdmin from "./pages/Admin/GPTDocAgentAdmin";
import GPTCockpit from "./pages/Admin/GPT_Cockpit";
import WissenstestAdmin from "./pages/Admin/WissenstestAdmin";
import WissenstestManagement from "./pages/Admin/WissenstestManagement";
import AssessmentOpsAdmin from "./pages/Admin/AssessmentOpsAdmin";
import TerminalConsole from "./components/GPT_TerminalConsole";

// ➕ NEU: German-Training
import German from "./pages/German";

// STB-Komponenten
import StbPreview from "./pages/stb/StbPreview";
import StbJobMarketplace from "./pages/stb/StbJobMarketplace";
import StbAdvCreate from "./pages/stb/Stb_adv_create";
import StbApplications from "./pages/stb/StbApplications";

// Rechtliches
import Impressum from "./pages/legal/Impressum";
import AGB from "./pages/legal/AGB";
import Datenschutz from "./pages/legal/Datenschutz";

// Hauptmenü
import MnuTools from "./pages/menue/Mnu_tools";
import MnuQuali from "./pages/menue/Mnu_qualy.js";
import MnuSuccess from "./pages/menue/Mnu_success.js";
import MnuSupport from "./pages/menue/Mnu_support.js";

import WithContainer from "./layouts/WithContainer";
import NoContainer from "./layouts/NoContainer";
import RouteSeo from "./components/RouteSeo";

/** Layout-Regeln (unverändert) */
const layoutConfig = {
  "/": "no",
  "/leitbild": "no",
  "/roadmap": "no",
  "/public/roadmap": "no",
  "/nachrichten": "no",
  "/stb/job-marketplace": "no",
  "/applicant/frontdoor": "no",
  "/login": "no",
  "/register": "no",
  "/impressum": "no",
  "/agb": "no",
  "/datenschutz": "no",
  "/dashboard/admin": "no",
  "/dashboard/account": "no",
  "/dashboard/applicant": "no",
  "/dashboard/applicant/erfolge": "no",
  "/dashboard/applicant/edit-profile": "no",
  "/dashboard/applicant/cv2": "no",
  "/dashboard/applicant/bewerbung": "no",
  "/dashboard/applicant/sprachtest-b1": "no",
  "/dashboard/applicant/filing-requests": "no",
  "/dashboard/applicant/matches": "no",
  "/dashboard/applicant/nachrichten": "no",
  "/dashboard/security": "no"
};

const fullWidthPrefixes = [
  "/dashboard/admin",
  "/dashboard/users",
  "/dashboard/employer",
  "/dashboard/stb",
  "/dashboard/security",
  "/dashboard/systemstatus",
  "/dashboard/newsticker",
  "/dashboard/nachrichten",
  "/dashboard/chatbot-admin",
  "/dashboard/faq-admin",
  "/dashboard/gpt",
  "/dashboard/gpt-maintainer",
  "/dashboard/gpt-docagent",
  "/dashboard/blog",
  "/dashboard/blog-editor",
  "/admin/gpt-terminal",
];

const publicFullWidthPrefixes = [
  "/menue/",
  "/nachrichten/",
];

function getLayout(pathname) {
  if (publicFullWidthPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix))) {
    return NoContainer;
  }
  if (fullWidthPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return NoContainer;
  }
  const layoutType = layoutConfig[pathname] || "yes";
  return layoutType === "no" ? NoContainer : WithContainer;
}

function ApplicantLegacyCvRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get("tab");
  const target = tab === "skills" ? "/dashboard/applicant/bewerbung?tab=skills" : "/dashboard/applicant/bewerbung?tab=cv";
  return <Navigate to={target} replace />;
}

/** Default-Settings für den Ticker (identisch zur Admin-UI) */
const defaultTickerSettings = {
  enabled: true,
  position: "fixed",
  placement: "top",
  width: "100%",
  background_color: "#f8fbff",
  text_color: "#0e1726",
  border: "",
  padding: "0px",
  margin: "0",
  animation_type: "marquee", // Admin kann umstellen: marquee | slide | fade | typing | none
  animation_speed: 40,       // Basiseinheit in Sekunden: je größer, desto langsamer
  pause_on_hover: true,
  autoplay: true,
  show_close_button: true,
  height_px: 58
};

function App() {
  const location = useLocation();
  const Layout = getLayout(location.pathname);
  const withEmployerMode = (element) => (
    <EmployerModeProvider>
      {element}
    </EmployerModeProvider>
  );
  const withApplicantCoach = (element) => (
    <ApplicantCoachProvider>
      {element}
    </ApplicantCoachProvider>
  );
  const showNewsTicker =
    !location.pathname.startsWith("/dashboard") &&
    location.pathname !== "/" &&
    location.pathname !== "/leitbild" &&
    location.pathname !== "/roadmap" &&
    location.pathname !== "/public/roadmap" &&
    location.pathname !== "/nachrichten" &&
    !location.pathname.startsWith("/nachrichten/") &&
    location.pathname !== "/stb/job-marketplace" &&
    location.pathname !== "/applicant/frontdoor" &&
    location.pathname !== "/login" &&
    location.pathname !== "/register";

  // -----------------------------
  // Globaler Newsticker-State
  // -----------------------------
  const [tickerSettings, setTickerSettings] = useState(defaultTickerSettings);
  const [tickerMessages, setTickerMessages] = useState([]);
  // Per-Message-Speed: 1 = normal, <1 = schneller, >1 = langsamer
  const [perMessageSpeed, setPerMessageSpeed] = useState([]);

  // Daten laden: erst /public (falls vorhanden), sonst /settings + /messages
  useEffect(() => {
    if (isPrerenderUserAgent()) {
      setTickerSettings(defaultTickerSettings);
      setTickerMessages([]);
      setPerMessageSpeed([]);
      return undefined;
    }

    (async () => {
      try {
        const r = await fetch(`${config.API_BASE_URL}/api/newsticker/public`);
        if (r.ok) {
          const data = await r.json();
          const settings = { ...defaultTickerSettings, ...(data?.settings || {}) };
          const messages = Array.isArray(data?.messages) ? data.messages : [];
          setTickerSettings(settings);
          setTickerMessages(messages);

          // Dein Wunsch: 3 Texte mit unterschiedlicher Geschwindigkeit
          setPerMessageSpeed(messages.length === 3 ? [1.0, 0.75, 1.5] : new Array(messages.length).fill(1));
          return;
        }
      } catch (_) {
        // ignorieren – wir fallen unten auf die Einzelrouten zurück
      }
      try {
        const [s, m] = await Promise.all([
          fetch(`${config.API_BASE_URL}/api/newsticker/settings`),
          fetch(`${config.API_BASE_URL}/api/newsticker/messages`)
        ]);
        const settings = s.ok ? await s.json() : {};
        const messages = m.ok ? await m.json() : [];
        setTickerSettings({ ...defaultTickerSettings, ...settings });
        setTickerMessages(Array.isArray(messages) ? messages : []);
        setPerMessageSpeed(Array.isArray(messages) && messages.length === 3 ? [1.0, 0.75, 1.5] : new Array(messages.length).fill(1));
      } catch (e) {
        console.warn("NewsTicker: Konnte Daten nicht laden:", e);
        // bei Fehler einfach nichts anzeigen (messages bleibt leer)
      }
    })();
    return undefined;
  }, []);

  // Bestehende Body-Hintergründe je nach Route
  useEffect(() => {
    const path = location.pathname;
    const isPublicLightRoute =
      path === "/" ||
      path === "/leitbild" ||
      path === "/roadmap" ||
      path === "/public/roadmap" ||
      path === "/nachrichten" ||
      path.startsWith("/nachrichten/") ||
      path === "/stb/job-marketplace" ||
      path === "/applicant/frontdoor" ||
      path === "/impressum" ||
      path === "/agb" ||
      path === "/datenschutz" ||
      path.startsWith("/menue/");
    if (process.env.NODE_ENV === "development") {
      console.log("start APP.js", path);
    }

    if (isPublicLightRoute) {
      document.body.classList.remove("landingpage-mode");
      document.body.style.background = "#f4f1e8";
      document.body.style.backgroundImage = "none";
      document.body.style.backgroundSize = "";
      document.body.style.backgroundPosition = "";
    } else {
      document.body.classList.remove("landingpage-mode");
      document.body.style.background = "";
      document.body.style.backgroundImage = "";
      document.body.style.backgroundSize = "";
      document.body.style.backgroundPosition = "";
    }
  }, [location]);

  return (
    <AppearanceProvider>
      <>
        <RouteSeo />

        {showNewsTicker ? (
          <NewsTicker
            messages={tickerMessages}
            settings={tickerSettings}
            perMessageSpeed={perMessageSpeed}
          />
        ) : null}

        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leitbild" element={<Leitbild />} />
            <Route path="/nachrichten" element={<Nachrichten />} />
            <Route path="/nachrichten/:slug" element={<NachrichtenArtikel />} />
            <Route path="/roadmap" element={<PublicRoadmapPage />} />
            <Route path="/public/roadmap" element={<PublicRoadmapPage />} />
            <Route path="/applicant/frontdoor" element={<ApplicantFrontdoorPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard/admin" element={<RoleGate allow={["admin"]}><AdminDashboard /></RoleGate>} />
            <Route path="/dashboard/admin/kvp" element={<RoleGate allow={["admin"]}><AdminKvpInbox /></RoleGate>} />
            <Route path="/dashboard/admin/trust-fraud" element={<RoleGate allow={["admin"]}><AdminTrustFraudCenter /></RoleGate>} />
            <Route path="/dashboard/admin/coreui-pro-showcase" element={<RoleGate allow={["admin"]}><AdminCoreUiProShowcasePage /></RoleGate>} />
            <Route path="/dashboard/users" element={<RoleGate allow={["admin"]}><UserAdmin /></RoleGate>} />
            <Route path="/dashboard/admin/users" element={<RoleGate allow={["admin"]}><UserAdmin /></RoleGate>} />
            <Route path="/dashboard/applicant" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantDashboardWithCoach />)}</RoleGate>} />
            <Route path="/dashboard/applicant/erfolge" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantAchievements />)}</RoleGate>} />
            <Route path="/dashboard/account" element={<RoleGate allow={["applicant", "employer", "press"]}><AccountSettings /></RoleGate>} />
            <Route path="/dashboard/applicant/edit-profile" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantEditProfile />)}</RoleGate>} />
            <Route path="/dashboard/applicant/bewerbung" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantApplicationWorkspace />)}</RoleGate>} />
            <Route path="/dashboard/applicant/sprachtest-b1" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantB1Workspace />)}</RoleGate>} />
            <Route path="/dashboard/applicant/filing-requests" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantFilingRequests />)}</RoleGate>} />
            <Route path="/dashboard/applicant/matches" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantMatches />)}</RoleGate>} />
            <Route path="/dashboard/applicant/nachrichten" element={<RoleGate allow={["applicant"]}>{withApplicantCoach(<ApplicantMessages />)}</RoleGate>} />
            <Route path="/dashboard/applicant/cv2" element={<RoleGate allow={["applicant"]}><ApplicantLegacyCvRedirect /></RoleGate>} />
            <Route path="/dashboard/employer" element={<RoleGate allow={["employer"]}>{withEmployerMode(<EmployerWorkspacePage />)}</RoleGate>} />
            <Route path="/dashboard/employer/jobs" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<EmployerJobsPage />)}</RoleGate>} />
            <Route path="/dashboard/employer/jobs/wizard" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<StbAdvCreate />)}</RoleGate>} />
            <Route path="/dashboard/employer/candidates" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<StbApplications />)}</RoleGate>} />
            <Route path="/dashboard/employer/documents" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<EmployerDocumentsPage />)}</RoleGate>} />
            <Route path="/dashboard/employer/compliance" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<EmployerCompliancePage />)}</RoleGate>} />
            <Route path="/dashboard/employer/integration" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<EmployerIntegrationPage />)}</RoleGate>} />
            <Route path="/dashboard/employer/analytics" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<EmployerAnalyticsPage />)}</RoleGate>} />
            <Route path="/dashboard/employer/profile" element={<RoleGate allow={["admin", "employer"]}>{withEmployerMode(<EmployerProfilePage />)}</RoleGate>} />
            <Route path="/dashboard/press" element={<RoleGate allow={["press"]}><PressDashboard /></RoleGate>} />
            <Route path="/dashboard/blog" element={<RoleGate allow={["admin"]}><BlogAdmin /></RoleGate>} />
            <Route path="/dashboard/blog-editor/:articleId" element={<RoleGate allow={["admin"]}><BlogEditor /></RoleGate>} />
            <Route path="/dashboard/wissenstest" element={<RoleGate allow={["admin", "applicant"]}><WissensTest /></RoleGate>} />
            <Route path="/assessment/wt" element={<RoleGate allow={["admin", "applicant"]}><WtStart /></RoleGate>} />
            <Route path="/assessment/wt/run/:attemptId" element={<RoleGate allow={["admin", "applicant"]}><WtRun /></RoleGate>} />
            <Route path="/assessment/wt/result/:attemptId" element={<RoleGate allow={["admin", "applicant"]}><WtResult /></RoleGate>} />
            <Route path="/assessment/wt/history" element={<RoleGate allow={["admin", "applicant"]}><WtHistory /></RoleGate>} />
            <Route path="/dashboard/admin/wissenstest" element={<RoleGate allow={["admin"]}><WissenstestAdmin /></RoleGate>} />
            <Route path="/dashboard/admin/wissenstest-management" element={<RoleGate allow={["admin"]}><WissenstestManagement /></RoleGate>} />
            <Route path="/dashboard/admin/assessment-ops" element={<RoleGate allow={["admin"]}><AssessmentOpsAdmin /></RoleGate>} />
            <Route path="/dashboard/newsticker" element={<RoleGate allow={["admin"]}><NewsTickerAdmin /></RoleGate>} />
            <Route path="/dashboard/nachrichten" element={<RoleGate allow={["admin"]}><AdminNewsPage /></RoleGate>} />
            <Route path="/dashboard/security" element={<RoleGate allow={["admin"]}><SecurityDashboard /></RoleGate>} />
            <Route path="/dashboard/systemstatus" element={<RoleGate allow={["admin"]}><SystemStatusAdmin /></RoleGate>} />
            <Route path="/dashboard/chatbot-admin" element={<RoleGate allow={["admin"]}><ChatBotAdmin /></RoleGate>} />
            <Route path="/dashboard/faq-admin" element={<RoleGate allow={["admin"]}><ChatbotFaqAdmin /></RoleGate>} />
            <Route path="/dashboard/gpt-maintainer" element={<RoleGate allow={["admin"]}><GPTMaintainerAdmin /></RoleGate>} />
            <Route path="/dashboard/gpt-docagent" element={<RoleGate allow={["admin"]}><GPTDocAgentAdmin /></RoleGate>} />
            <Route path="/admin/gpt-terminal" element={<RoleGate allow={["admin"]}><TerminalConsole /></RoleGate>} />
            <Route path="/dashboard/gpt" element={<RoleGate allow={["admin"]}><GPTCockpit /></RoleGate>} />

            {/* ➕ NEU: German-Training */}
            <Route path="/dashboard/german" element={<RoleGate allow={["admin", "applicant"]}><German /></RoleGate>} />

            <Route path="/stb/job-marketplace" element={<StbJobMarketplace />} />
            <Route path="/stb/preview/:id" element={<StbPreview />} />
            <Route path="/dashboard/stb/edit/:id" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyEditRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/verwaltung" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyManageRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/anzeigen" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyManageRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/create" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyCreateRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/manage" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyManageRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/applications" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyCandidatesRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/preview/:id" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyPreviewRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/analyse/:id" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyAuthoringRedirect /></RoleGate>} />
            <Route path="/dashboard/stb/translate/:adv_id" element={<RoleGate allow={["admin", "employer"]}><EmployerLegacyAuthoringRedirect /></RoleGate>} />

            <Route path="/impressum" element={<Impressum />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/datenschutz" element={<Datenschutz />} />

            <Route path="/menue/tools" element={<MnuTools />} />
            <Route path="/menue/quali" element={<MnuQuali />} />
            <Route path="/menue/success" element={<MnuSuccess />} />
            <Route path="/menue/support" element={<MnuSupport />} />
          </Routes>
        </Layout>
      </>
    </AppearanceProvider>
  );
}

export default App;
